import { ReactNode, useMemo, useState } from 'react';

import { FixedNotifications, INotification } from '@ergeon/core-components/exports/FixedNotifications.ts';

import { ToastsContext, ToastInput } from '@/components/Toast/context';

const TYPE_BY_VARIANT: Record<NonNullable<ToastInput['variant']>, INotification['type']> = {
  destructive: 'Error',
  success: 'Success',
  info: 'Information',
  default: 'Information',
};

export default function ToastsProvider({ children }: { children: ReactNode }) {
  const [notifications, setNotifications] = useState<INotification[]>([]);

  const imperativeToasts = useMemo(() => ({
    publish({ text, variant }: ToastInput) {
      setNotifications(existing => [
        ...existing,
        { msg: text, type: TYPE_BY_VARIANT[variant ?? 'default'] },
      ]);
    },
  }), []);

  return (
    <ToastsContext.Provider value={imperativeToasts}>
      {children}
      {/* The core component positions itself absolutely, so on a scrolled page
          it would sit above the viewport. This zero-size fixed anchor at the
          viewport corner keeps it on screen wherever the page is. */}
      <div className="fixed bottom-0 left-0 z-50">
        <FixedNotifications notifications={notifications} setNotifications={setNotifications} />
      </div>
    </ToastsContext.Provider>
  );
}
